// A rich text editor as a web component: rhino-editor's TipTap element, with
// its toolbar cut down. The whole of its contract with a form is one hidden
// input -- `input` names that input's id, the editor opens on its value, and
// every keystroke serializes back into it, so nothing else on the page has to
// know it is there:
//
//   <%= form.hidden_field :body, id: "post_body" %>
//   <rich-text-editor input="post_body"></rich-text-editor>
//
// What comes back is user-authored HTML, and it goes out again only through
// ApplicationHelper#rich_text. The toolbar below is trimmed to exactly what
// that allowlist survives -- offer an author a code block or a horizontal rule
// and they would watch it vanish the first time the page renders what they
// saved. Widening one means widening the other.
//
// Attachments are off for a second reason: uploading one wants ActionText,
// which this app deliberately does not have (Active Storage is here; the
// ActionText-flavoured half of rhino is unused).
import { TipTapEditor } from "rhino-editor/exports/elements/tip-tap-editor.js"

class RichTextEditor extends TipTapEditor {
  constructor() {
    super()

    this.starterKitOptions = {
      ...this.starterKitOptions,
      code: false,
      codeBlock: false,
      horizontalRule: false,
      heading: { levels: [1, 2] },
      rhinoAttachment: false,
      rhinoGallery: false,

      // Goes with `code: false` and is not optional: the codemark plugin reads
      // the code mark out of the schema on every transaction, and with no such
      // mark in it the plugin throws there -- which means the editor accepts no
      // input at all, silently, with the page otherwise looking fine.
      rhinoCodemarkPlugin: false,
    }
  }
}

RichTextEditor.define("rich-text-editor")
